export default __webpack_public_path__ + "static/media/custom.97d748af.jpg";